import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { Notification } from '@/store/notifications/types'
import { RootState } from '@/store/types'

export const getDefaultState = () => {
  return {
    emailsNotification: [],
    groupEmailsNotification: []
  }
}

export const state: Notification = getDefaultState()

const namespaced = true

export const notifications: Module<Notification, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
